import { Box, CardMedia, Stack, Typography } from "@mui/material";
import React from "react";
import { CURRENCY } from "../../lib/variables";
import { useSelector } from "react-redux";

const SelectedServiceCard = ({ serviceDetail }) => {
    const { currentLanguage } = useSelector((state) => state.translationReducer);
  
  return (
    <Stack
      direction={{ md: "row" }}
      spacing={2}
      alignItems="center"
      overFlow={"hidden"}
      sx={{
        padding: 2,
        border: "1px solid #d9d3d3",
        borderRadius: 2,
        backgroundColor: "#f9f9f9",
      }}
    >
      <CardMedia
        component="img"
        image={serviceDetail?.serviceSubCategoryId?.image}
        sx={{
          height: { xs: "100%", md: "160px" },
          width: { xs: "100%", md: "160px" },
          borderRadius: "8px",
          flexShrink: 0,
        }}
      />
      <Box overflow={"hidden"}>
        <Typography variant="h6" fontWeight={600} textTransform={"capitalize"}>
          {serviceDetail?.serviceSubCategoryId?.name[currentLanguage]}
        </Typography>
        <Typography
          variant="body2"
          color="text.mediumGray"
          sx={{ lineHeight: 1.5, mt: 1 }}
          // noWrap
        >
          {serviceDetail?.serviceSubCategoryId?.description[currentLanguage]}
        </Typography>

        {serviceDetail?.serviceSubCategoryId?.type === "fixed" && (
          <Typography
            variant="body2"
            color="text.mediumGray"
            fontWeight={600}
            mt={1}
          >
            Service Charge: {CURRENCY} {serviceDetail?.price?.fixed || 0}
          </Typography>
        )}
        {serviceDetail?.serviceSubCategoryId?.type === "area" && (
          <Typography
            variant="body2"
            color="text.mediumGray"
            fontWeight={600}
            mt={1}
          >
            Per Area Charge: {CURRENCY} {serviceDetail?.price?.area || 0}
          </Typography>
        )}

        {serviceDetail?.serviceSubCategoryId?.type === "room+area" && (
          <Typography
            variant="body2"
            color="text.mediumGray"
            fontWeight={600}
            mt={1}
          >
            Per Area Charge: {CURRENCY} {serviceDetail?.price?.area || 0} <br />
            Per Room Charge: {CURRENCY} {serviceDetail?.price?.room || 0}
          </Typography>
        )}
        {serviceDetail?.serviceSubCategoryId?.type === "interior+exterior" && (
          <Typography
            variant="body2"
            color="text.mediumGray"
            fontWeight={600}
            mt={1}
          >
            Interior Service Charge: {CURRENCY}{" "}
            {serviceDetail?.price?.interior || 0} <br />
            Exterior Service Charge: {CURRENCY}{" "}
            {serviceDetail?.price?.exterior || 0}
          </Typography>
        )}
      </Box>
    </Stack>
  );
};

export default SelectedServiceCard;
